// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var CreditCard = function CreditCard(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M14.029 2.542H1.971A1.429 1.429 0 00.544 3.969v8.061a1.43 1.43 0 001.427 1.428h12.058a1.429 1.429 0 001.427-1.428V3.969a1.429 1.429 0 00-1.427-1.427zm.427 9.487a.433.433 0 01-.427.428H1.971a.433.433 0 01-.427-.428V8.107h12.912zm0-6.59H1.544v-1.47a.433.433 0 01.427-.427h12.058a.433.433 0 01.427.427z"
    }))
  );
};

export default CreditCard;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/CreditCard.js
// module id = 995
// module chunks = 0